module.exports = __webpack_public_path__ + "static/media/James Wacksman VPMA Headshot_1681113602599.12aac7d5.png";